import { Box, Grid2 as Grid, Typography } from '@mui/material';
import React from 'react';
import { TextArea, EnumDropdown } from 'framework/form';

interface PostponeFormProps {
  postponeKey?: string;
  postponeReason?: string;
  postponeOptions: Record<string, string>;
  postponeOptionErrors: string[];
  postponeReasonErrors: string[];
  onPostponeKeyChange: (key: string) => void;
  onPostponeReasonChange: (reason: string) => void;
}

const PostponeForm: React.FC<PostponeFormProps> = ({
  postponeKey,
  postponeReason,
  postponeOptions,
  postponeOptionErrors,
  postponeReasonErrors,
  onPostponeKeyChange,
  onPostponeReasonChange,
}) => (
  <Box mt={3}>
    <Typography variant="h5" mb={2}>
      Postpone Information
    </Typography>
    <Grid container spacing={2}>
      <Grid size={12}>
        <EnumDropdown
          source="postponeKey"
          label="Postpone Period"
          value={postponeKey || ''}
          onChangeCallback={(event: any) => onPostponeKeyChange(event.postponeKey)}
          options={postponeOptions}
          placeholder="Select postpone period"
          errorMessages={postponeOptionErrors}
          isRequired
        />
      </Grid>
      <Grid size={12}>
        <TextArea
          source="postponeReason"
          label="Reason for Postponing"
          placeholder="Explain why these issues are being postponed"
          onChangeCallback={(inputData: any) => onPostponeReasonChange(inputData.postponeReason)}
          value={postponeReason || ''}
          errorMessages={postponeReasonErrors}
          isRequired
        />
      </Grid>
    </Grid>
  </Box>
);

export default PostponeForm;
